import React, {useCallback, useState} from 'react'
import {toast} from 'react-toastify'
import {Button} from '../../../../accountManagement/shared/Button'
import {GeneratedLinkModal} from '../../../../accountManagement/features/AccountSetup/components/GeneratedLinkModal'
import {GeneratingLinkModal} from '../../../../accountManagement/features/AccountSetup/components/GeneratingLinkModal'
import {useAuthClient} from '../../../../utils/use-auth-client'
import {getErrorMessage} from '../kp-11Link-generateLink/kp-11Link-generateUrl'

// Generate Link for the shared-catalog 1:Many page. Posts the same endpoint and
// body the legacy page does (see manyLinkPayload). While it runs it shows a
// "Generating link…" modal (spinner + message), then the "Generated Link" copy
// modal — both on the Account Management Modal.
export function KPManyLinkGenerate({disabled, buildPayload}) {
  const client = useAuthClient()
  const [isGenerating, setIsGenerating] = useState(false)
  const [generatedLink, setGeneratedLink] = useState('')

  const handleGenerate = useCallback(async () => {
    const payload = buildPayload()
    if (!payload.keapPartnerId) {
      toast.error('Keap Partner Id value is missing  ')
      return
    }
    const unpricedFee = payload.oneTimeFees.find(
      fee => fee?.unitAmount === undefined || fee?.unitAmount === null,
    )
    if (unpricedFee) {
      toast.error(
        `Cannot generate the link because ${
          unpricedFee.name || unpricedFee.code
        } does not have a price configured.`,
      )
      return
    }
    setIsGenerating(true)
    try {
      const response = await client('cc/order/keap-partner/generate-link', {
        data: payload,
      })
      if (response?.generatedUrl) {
        setGeneratedLink(response.generatedUrl)
      } else {
        toast.error('Unable to generate the link. Please try again.')
      }
    } catch (error) {
      toast.error(
        `We encountered an error while updating data, Please contact Admin. Error: ${getErrorMessage(
          error,
        )}`,
      )
    } finally {
      setIsGenerating(false)
    }
  }, [buildPayload, client])

  return (
    <>
      <Button
        variant="solid-gradiant"
        size="sm"
        onClick={handleGenerate}
        disabled={disabled || isGenerating}
        isLoading={isGenerating}
        style={{width: '100%'}}
      >
        Generate Link
      </Button>
      <GeneratingLinkModal isOpen={isGenerating} />
      <GeneratedLinkModal
        link={generatedLink}
        onClose={() => setGeneratedLink('')}
      />
    </>
  )
}
